import {isLocalApi} from 'src/env'
import {restApiServiceLetters} from './service'
import {localApiServiceLetters} from './serviceLocal'

const APIServiceLetters = isLocalApi ? localApiServiceLetters : restApiServiceLetters
APIServiceLetters.init()

export default APIServiceLetters
